import { Skeleton, SkeletonItem, Task, TaskReferences } from '../models/dashboard-models';
import interceptor from '../restServiceInterceptor';
import { Filter } from '../models/table-models';

export const useGetAllTaskSkeletons = (branchIds: string[], taskType: string = 'MAINTENANCE'): Promise<Skeleton[]> => {
    let requestParams = new URLSearchParams();
    branchIds.map((id) => requestParams.append('branchIds', id));
    if (taskType === 'INSTALLATION' || taskType === 'DEVICE_RETURN') return Promise.all([]);
    // return interceptor.get(`/work-service/request/task/getAll?category=${taskType}&${requestParams}`);
    return interceptor.get(`warehouse-service/api/branchDevice/getAllResourceByBranchIds?${requestParams}`);
};

export const addTaskFromRequest = (
    branchId: number,
    targetDate: string,
    category: string,
    requestItems: SkeletonItem[],
    assigneeId: number,
    description?: string
): Promise<Task> => {
    const items = requestItems.map((item) => {
        return { itemId: item.itemId, itemCount: item.count, deviceId: item.deviceId };
    });
    return interceptor.post(`work-service/request/task/createFromRequest`, {
        requestId: {
            branchId,
            targetDate,
            targetDay: targetDate,
            items,
            details: description,
        },
        category,
        assigneeId,
    });
};

export const changeTaskAssignee = (taskId: number, assigneeId?: number) => {
    return interceptor.post(`work-service/tasks/changeTaskAssignee?taskId=` + taskId + '&newAssigneeId=' + assigneeId);
};

export const changeTasksAssignee = (taskIds: number[], assigneeId: number) => {
    return interceptor.post('work-service/tasks/tools/changeAssignee/selected', {}, {
        params: { taskIds, newAssigneeId: assigneeId },
        paramsSerializer: (params) => {
            return Object.keys(params)
                .map((key) => {
                    const value = params[key];
                    if (Array.isArray(value)) {
                        return value
                            .map((val) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`)
                            .join('&');
                    }
                    return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
                })
                .join('&');
        },
    });
};

export const getTaskById = (taskId: number | undefined): Promise<Task> => {
    return interceptor.get(`work-service/tasks/getById`, { params: { taskId } });
};

export const getReferences = (filter: Filter): Promise<TaskReferences[]> => {
    return interceptor.post(`work-service/tasks/getReferences`, {
        fromDate: filter.after,
        toDate: filter.before ?? new Date().toISOString(),
        userIds: filter.tags,
    });
};
